import gql from 'graphql-tag';

export default gql`
    mutation createReview($bookingId: String, $reviews: [ReviewInput]) {
        createReview(bookingId: $bookingId, reviews: $reviews) {
            id
        }
    }`;
